import React, { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigation } from 'react-router-dom'
import styled from 'styled-components'

import { FullScreenSpinner } from '@/components/Spinner.tsx'
import { Header4 } from '@/components/Text.tsx'
import { useAppointmentStore } from '@/store.ts'

export const MIN_SCREEN_WIDTH = 320
export const MAX_SCREEN_CONTENT_WIDTH = 428
export const HEADER_HEIGHT = 70

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100vh;
  height: 100svh;

  max-height: 100vh;
  min-width: ${MIN_SCREEN_WIDTH}px;
  max-width: 100%;
`

const ScreenContent = styled.div`
  position: relative;
  padding: 32px 20px;
  flex: 1;
  display: flex;
  flex-flow: column;
  width: 100%;
  max-width: ${MAX_SCREEN_CONTENT_WIDTH}px;
  overflow-y: auto;
`

const HeaderText = styled(Header4)`
  font-weight: 500;
  color: ${({ theme }) => theme.colors.common.black95};
`

const Header = styled.div`
  background: ${({ theme }) => theme.colors.common.white};
  box-shadow: ${({ theme }) =>
    `0px 1.4px 14px 0px ${theme.colors.common.black05}`};
  padding: 24px 16px;
  align-items: flex-end;
  position: relative;
  display: flex;
  justify-content: center;
  width: 100%;
  flex: 0 0 ${HEADER_HEIGHT}px;
`

export const ScreenWrapper = ({
  children,
}: {
  children: React.ReactNode
}): ReactElement => {
  const navigation = useNavigation()
  const { t } = useTranslation('translation')
  const container = useAppointmentStore((state) => state.embed)
  const isPending =
    navigation.state === 'loading' || navigation.state === 'submitting'

  return (
    <Wrapper>
      {container !== 'app' && (
        <Header>
          <HeaderText>{t('navHeader')}</HeaderText>
        </Header>
      )}
      <ScreenContent>
        {isPending ? <FullScreenSpinner /> : children}
      </ScreenContent>
    </Wrapper>
  )
}
